<template>
  <BaseModal :value="true" @input="close">
    <BasePackageForm
      v-if="showPackageForm"
      :receiptId="receipt.id"
      @close="showPackageForm = false"
      @package-added="fetchReceipt"
    />
    <div class="px-4 pt-6 h-full flex flex-col" v-if="receipt">
      <div
        id="action-buttons"
        class="absolute top-0 right-10 mt-4 mr-4 flex flex-row gap-2"
      >
        <a
          class="dark-button"
          :href="`${baseUrl}order_receipts/print_receipt_labels/${receipt.id}`"
          target="_blank"
        >
          Print Labels
        </a>
        <a
          class="dark-button"
          :href="`${baseUrl}order_receipts/print_receipt/${receipt.id}`"
          target="_blank"
        >
          Print Receipt
        </a>
        <button
          class="dark-button"
          @click="markAsShipped"
          v-if="receipt.status !== 'shipped'"
        >
          Mark as Shipped
        </button>
      </div>
      <h2 class="font-bold">
        Dispatch Receipt {{ receipt.createdAt | dateWithHours }}
      </h2>
      <div id="header-grid" class="flex flex-col lg:grid lg:grid-cols-3 gap-2">
        <div class="item">
          <h3>
            Deliver to:
          </h3>
          <!-- <BaseInfoautoPersonSelector
            :currentPersonId="receipt.receiverInfoautoId"
            :email="receipt.receiverInfoautoEmail"
            :phone="receipt.receiverInfoautoPhone"
            :name="receipt.receiverInfoautoName"
            :address="receipt.receiverInfoautoAddress"
            @selected="e => selectedPerson('deliver', e)"
          /> -->
          <OrderAddress
            :address="receipt.forwarderAddress"
            v-if="receipt.forwarderAddress"
          />
          <div class="alert" v-else>
            <p>Forwarder address not set, ask your seller to update</p>
          </div>
        </div>
        <div class="item">
          Final Destination:
          <!-- <BaseInfoautoPersonSelector
            :currentPersonId="receipt.destinationCustomerInfoautoId"
            :email="receipt.destinationCustomerInfoautoEmail"
            :phone="receipt.destinationCustomerInfoautoPhone"
            :name="receipt.destinationCustomerInfoautoName"
            :address="receipt.destinationCustomerInfoautoAddress"
            @selected="e => selectedPerson('final', e)"
          /> -->
          <OrderAddress :address="receipt.destinationAddress" />
        </div>
        <div class="item">
          General information
          <p>
            Status: <b>{{ receipt.status }}</b>
          </p>
          <p>Created: {{ receipt.createdAt | dateWithHours }}</p>
        </div>
      </div>
      <hr class="my-4" />
      <table class="w-full table">
        <thead class="bg-gray-200">
          <tr>
            <th>Package</th>
            <th>Dimensions</th>
            <th>Notes</th>
            <th>Weight</th>
            <th>Quantity</th>
            <th></th>
            <!-- <th>Volume Weight</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in receipt.items" :key="item.id">
            <td class="text-center">{{ item.boxType }}</td>
            <td class="text-center">
              W: {{ item.boxWidth }} X H:{{ item.boxHeight }} X L:{{
                item.boxLength
              }}
            </td>
            <td>{{ item.notes }}</td>
            <td class="text-center">{{ item.boxWeight }} lbs</td>
            <td class="text-center">{{ item.quantity }}</td>
            <td class="text-center">
              <button
                class="dark-button"
                v-if="receipt.status !== 'shipped'"
                @click="deletePackage(item.id)"
              >
                delete
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <button
        class="dark-button mt-4 w-44"
        @click="addPackage"
        v-if="receipt.status !== 'shipped'"
      >
        Add package
      </button>
    </div>
  </BaseModal>
</template>
<script>
import OrderAddress from "@/components/order/OrderAddress.vue";
import {
  getDispatchReceipt,
  updateDispatchReceipt,
  deleteDispatchReceiptItem
} from "@/api/DispatchReceiptService.js";
export default {
  data() {
    return {
      receipt: null,
      showPackageForm: false
    };
  },
  props: {
    receiptId: {
      type: String,
      required: true
    }
  },
  components: {
    OrderAddress
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_NKRSYNC_BE;
    }
  },
  mounted() {
    this.fetchReceipt();
    // window.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    // window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    deletePackage(itemId) {
      deleteDispatchReceiptItem(itemId)
        .then(() => {
          this.fetchReceipt();
          this.$toast.success("Package deleted");
        })
        .catch(() => {
          this.$toast.error("Error deleting package");
        });
    },
    selectedPerson(type, person) {
      const newReceipt = { ...this.receipt };
      console.log("selectedPerson", type, person);
      console.log(newReceipt);
      switch (type) {
        case "deliver":
          newReceipt.receiverInfoautoId = person?.personId || null;
          newReceipt.receiverInfoautoName = person?.name || null;
          newReceipt.receiverInfoautoEmail = person?.email || null;
          newReceipt.receiverInfoautoPhone = person?.phone || null;
          newReceipt.receiverInfoautoAddress = person?.address || null;
          break;
        case "final":
          newReceipt.destinationCustomerInfoautoAddressId =
            person?.addressId || null;
          newReceipt.destinationCustomerInfoautoId = person?.personId || null;
          newReceipt.destinationCustomerInfoautoName = person?.name || null;
          newReceipt.destinationCustomerInfoautoEmail = person?.email || null;
          newReceipt.destinationCustomerInfoautoPhone = person?.phone || null;
          newReceipt.destinationCustomerInfoautoAddress =
            person?.address || null;
          break;
      }
      updateDispatchReceipt(this.receipt.id, newReceipt)
        .then(updatedReceipt => {
          this.receipt = updatedReceipt;
        })
        .catch(error => {
          console.error(error);
        });
    },
    markAsShipped() {
      const newReceipt = { ...this.receipt };
      newReceipt.status = "shipped";
      updateDispatchReceipt(this.receipt.id, newReceipt)
        .then(updatedReceipt => {
          this.receipt = updatedReceipt;
        })
        .catch(error => {
          console.error(error);
        });
    },
    addPackage() {
      this.showPackageForm = true;
    },
    fetchReceipt() {
      getDispatchReceipt(this.receiptId)
        .then(receipt => {
          this.receipt = receipt;
        })
        .catch(error => {
          console.error(error);
        });
    },
    close() {
      console.log("close");
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
#header-grid {
  margin-top: 20px;
  .item {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
}
.table {
  th {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  tbody {
    tr {
      td {
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
      }
    }
  }
}
</style>
